import { Injectable, Type } from '@angular/core';
import { Router } from '@angular/router';
import {
  AuthService,
  ButtonsComponent,
  CartTotalStepComponent,
  CheckoutStepComponent,
  GungFlowService
} from 'gung-standard';
import {
  AssignJeevesDefaultsComponent,
  AssignOrderRowsJeevesComponent,
  DeliveryLocationsJeevesComponent,
  JeevesCheckoutConfigService,
  OrderTermsJeevesComponent,
  SummarizeOrderJeevesComponent,
  JeevesCustomerConfigService
} from 'gung-standard-jeeves';
import { forkJoin, Observable } from 'rxjs';
import { first, map } from 'rxjs';
import { CultCheckoutButtonsComponent } from '../components/checkout/cult-checkout-buttons/cult-checkout-buttons.component';
import { AssignOrderRowsCultComponent } from '../components/checkout/steps/assign-order-rows-cult/assign-order-rows-cult.component';
import { CultCartTotalStepComponent } from '../components/checkout/steps/cult-cart-total-step/cult-cart-total-step.component';
import { CultCreateUnifaunReturnStepComponent } from '../components/checkout/steps/cult-create-unifaun-return-step/cult-create-unifaun-return-step.component';
import { CultOrderTermsJeevesComponent } from '../components/checkout/steps/cult-order-terms-jeeves/cult-order-terms-jeeves.component';
import { CultReturnInfoStepComponent } from '../components/checkout/steps/cult-return-info-step/cult-return-info-step.component';
import { CultCheckoutDefaultsComponent } from '../components/cult-checkout-defaults/cult-checkout-defaults.component';
import { CultDeliveryLocationsComponent } from '../components/cult-delivery-locations/cult-delivery-locations.component';
import { CultSummarizeOrderComponent } from '../components/cult-summarize-order/cult-summarize-order.component';

@Injectable({
  providedIn: 'root'
})
export class CultCheckoutConfigService extends JeevesCheckoutConfigService {
  getMainProcessSteps(): Observable<Type<CheckoutStepComponent>[]> {
    return forkJoin([
      this.gungFlowService.getSelectedFlow().pipe(first()),
      super.getMainProcessSteps().pipe(first())
    ]).pipe(
      first(),
      map(([flow, superSteps]) => {
        const steps = [];
        steps.push(...superSteps);

        if (steps.indexOf(CartTotalStepComponent) >= 0) {
          steps[steps.indexOf(CartTotalStepComponent)] = CultCartTotalStepComponent;
        }
        if (steps.indexOf(SummarizeOrderJeevesComponent) >= 0) {
          steps[steps.indexOf(SummarizeOrderJeevesComponent)] = CultSummarizeOrderComponent;
        }
        if (steps.indexOf(AssignOrderRowsJeevesComponent) >= 0) {
          steps[steps.indexOf(AssignOrderRowsJeevesComponent)] = AssignOrderRowsCultComponent;
        }
        if (steps.indexOf(DeliveryLocationsJeevesComponent) >= 0) {
          steps[steps.indexOf(DeliveryLocationsJeevesComponent)] = CultDeliveryLocationsComponent;
        }
        if (steps.indexOf(OrderTermsJeevesComponent) >= 0) {
          steps[steps.indexOf(OrderTermsJeevesComponent)] = CultOrderTermsJeevesComponent;
        }
        if (flow.isReturnOrder) {
          if (steps.indexOf(CultDeliveryLocationsComponent) >= 0) {
            steps[steps.indexOf(CultDeliveryLocationsComponent)] = CultReturnInfoStepComponent;
          }
          if (!flow.extra?.isReturnOrderWithoutFreight) {
            steps.push(CultCreateUnifaunReturnStepComponent); // Has to be last step!
          }
          if (steps.indexOf(OrderTermsJeevesComponent) >= 0) {
            steps.splice(steps.indexOf(OrderTermsJeevesComponent), 1);
          }
        }
        if (flow.extra.isReturnOrderWithoutFreight) {
          if (steps.indexOf(CultReturnInfoStepComponent) >= 0) {
            steps.splice(steps.indexOf(CultReturnInfoStepComponent), 1);
          }
        }
        return steps;
      })
    );
  }

  getInternalPreProcessSteps(): Observable<Type<CheckoutStepComponent>[]> {
    return super.getInternalPreProcessSteps().pipe(
      map(d => {
        d[d.indexOf(AssignJeevesDefaultsComponent)] = CultCheckoutDefaultsComponent;
        return d;
      })
    );
  }

  getButtonsComponent(): Type<ButtonsComponent> {
    return CultCheckoutButtonsComponent;
  }
}
